import React from 'react'
// import { connect } from 'react-redux'
// import { makeStyles } from '@material-ui/core/styles'
import PageLayout from '../PageLayout'
import RolesTable from './RolesTable'

// const useStyles = makeStyles(theme => ({
//   content: {
//     padding: theme.spacing(4)
//   },
// }))


export default function RolesPage(props) {
  // const classes = useStyles()

  // console.log('RolesPage render')

  return (
    <PageLayout mainDrawer={true} >
      <RolesTable />
    </PageLayout>

  )
}

// const mapStateToProps = store => {
//   const { application, mainLayout } = store
//   return {
//     apps: application.list,
//     permissionMap: mainLayout.readProfile.permissionMap
//   }
// }

// export default connect(mapStateToProps)(RolesPage)
